<template>
  <b-row v-if="showTotals">
    <b-col :md="2"><div></div></b-col>
    <b-col :md="4">
      <div class="text-right">
        <p class="pt-8"><b>Стойност на фактурата:</b></p>
      </div>
    </b-col>
    <b-col :md="2">
      <b-form-group
        id="item-bill-measure-group"
        :label="$t('FORM_LABELS.VALUE_NO_VAT')"
        label-for="bill-invoice-total-value"
      >
        <div class="input-group">
          <FormInput
            id="bill-invoice-total-value"
            type="number"
            name="bill_total_value"
            disabled
            :i18n="{
              label: 'FORM_LABELS.VALUE_NO_VAT',
              placeholder: $t('FORM_LABELS.VALUE_NO_VAT')
            }"
            :validations="'validations: {required: false, minLength: 0}'"
            :validateState="{}"
            :value="totalNoVat"
          ></FormInput>
        </div>
      </b-form-group>
    </b-col>
    <b-col :md="2">
      <b-form-group
        id="item-bill-vat-group"
        :label="$t('FORM_LABELS.VALUE_VAT')"
        label-for="bill-invoice-vat"
      >
        <div class="input-group">
          <FormInput
            id="bill-invoice-vat"
            type="number"
            name="vat"
            disabled
            :i18n="{
              label: 'FORM_LABELS.VAT',
              placeholder: $t('FORM_LABELS.VALUE_VAT')
            }"
            :validations="'validations: {required: false, minLength: 0}'"
            :validateState="{}"
            :value="vat"
          ></FormInput>
        </div>
      </b-form-group>
    </b-col>
    <b-col :md="2">
      <b-form-group
        id="item-bill-with-vat-group"
        :label="$t('FORM_LABELS.VALUE_WITH_VAT')"
        label-for="bill-invoice-w-vat"
      >
        <div class="input-group">
          <FormInput
            id="bill-invoice-w-vat"
            type="number"
            name="withVat"
            disabled
            :i18n="{
              label: 'FORM_LABELS.VALUE_WITH_VAT',
              placeholder: $t('FORM_LABELS.VALUE_WITH_VAT')
            }"
            :validations="'validations: {required: false, minLength: 0}'"
            :validateState="{}"
            :value="totalWithVat"
          ></FormInput>
        </div>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import FormInput from "@/view/content/forms/components/FormInput.vue";

export default {
  name: "FuelExpenseFormTotals",
  components: {
    FormInput
  },
  props: {
    totalNoVat: {
      type: [Number, String],
      default: 0
    },
    vat: {
      type: [Number, String],
      default: 0
    },
    totalWithVat: {
      type: [Number, String],
      default: 0
    },
    showTotals: {
      type: Boolean,
      default: true
    }
  }
};
</script>
